import styled from "@emotion/styled";

import { AdSlot } from "~/components/advertisement/ad-slots/ad-slot";
import { Loading } from "~/components/common/loading";
import { ContentItemRender } from "~/components/content/content-item-render";
import { NewsletterWidgetContainer } from "~/components/newsletter/newsletter-widget-container";
import { TopicSponsorArticles } from "~/components/topic/topic-sponsor-articles";
import { setFullViewportWidthStyles } from "~/lib/styles";

export const StyledAdSlot = styled(AdSlot)`
  padding-block-end: 20px;

  ${props => props.theme.breakpoints.up("desktop")} {
    padding-block-end: 0;
  }
`;

export const MainContainer = styled.div``;

export const StyledNewsletterWidgetContainer = styled(NewsletterWidgetContainer)`
  display: none;

  margin-block-start: 32px;
  ${props => props.theme.breakpoints.up("tablet")} {
    display: flex;
    justify-content: center;
  }

  ${props => props.theme.breakpoints.up("desktop")} {
    margin-block-start: 0;
  }
`;

export const NewsletterAdsContainer = styled.div`
  inline-size: 100%;

  ${props => props.theme.breakpoints.only("mobile")} {
    ${setFullViewportWidthStyles()}
  }
`;

export const NativeAdContainer = styled.div`
  inline-size: 100%;

  ${props => props.theme.breakpoints.up("tablet")} {
    margin-block-start: 32px;
  }

  ${props => props.theme.breakpoints.up("desktop")} {
    display: block;

    margin-block: 32px 0;
    margin-inline: 12px;
  }
`;

export const NewsletterAndAdsContainer = styled.div`
  display: grid;
  grid-template-areas:
    "newsletter"
    "newsletter-ad"
    "native-ad";
  justify-items: stretch;
  align-items: center;

  ${props => props.theme.breakpoints.up("tablet")} {
    grid:
      "newsletter-ad" min-content
      "newsletter" min-content
      "native-ad" min-content
      / 1fr;

    padding-block-start: 32px;
  }

  ${props => props.theme.breakpoints.up("desktop")} {
    grid:
      "newsletter newsletter-ad" min-content
      "native-ad native-ad" min-content
      / 1fr 300px;

    padding-block-start: 32px;
  }

  ${StyledNewsletterWidgetContainer} {
    grid-area: newsletter;
  }

  ${NewsletterAdsContainer} {
    grid-area: newsletter-ad;
  }

  ${NativeAdContainer} {
    grid-area: native-ad;
  }
`;

export const StyledTopicSponsorArticles = styled(TopicSponsorArticles)``;

export const Item = styled(ContentItemRender)`
  padding-block: 20px;
`;

export const ContentContainer = styled.div`
  > * + ${Item} {
    border-block-start: 1px solid #e5e5e5;
  }

  > ${StyledTopicSponsorArticles} + ${Item} {
    border-block-start: 1px solid #000000;
  }

  > * + ${StyledTopicSponsorArticles} {
    border-block-start: 1px solid #000000;
  }

  ${props => props.theme.breakpoints.up("tablet")} {
    > ${Item}:first-child {
      padding-block-start: 0;
    }
    > ${Item}:nth-child(2) {
      border-block-start: 0;
    }
  }
`;

export const StyledLoading = styled(Loading)`
  padding-block-end: 60px;
`;
